/**
 * Stage presentation flag for kiosk shells.
 * Set when media has been mounted; cleared only on intentional blank
 * (revoke / leave playback) — never on playlist restart.
 */
export const STAGE_PRESENTED_ATTR = 'data-gs-presented';
export function markStagePresented(root) {
    root.setAttribute(STAGE_PRESENTED_ATTR, 'true');
}
export function clearStagePresented(root) {
    root.removeAttribute(STAGE_PRESENTED_ATTR);
}
export function isStagePresented(root) {
    return root.getAttribute(STAGE_PRESENTED_ATTR) === 'true';
}
//# sourceMappingURL=presentation-state.js.map